import lookupOptionsApi from "@/services/api/lookupOptions";
import wellbeingApi from "@/services/api/wellbeing";

const CASE_NOTE_LOOKUP_TYPES = [
    "contact_type",
    "with_whom",
    "contact_location",
    "risk_type",
];

let pendingRequest = null;

const fetchCaseNoteOptions = async () => {
    const [lookupResponse, wellbeingResponse] = await Promise.all([
        lookupOptionsApi.listOptions(CASE_NOTE_LOOKUP_TYPES),
        wellbeingApi.wellbeingAreas(),
    ]);

    const lookups = lookupResponse.data || {};
    return {
        lookupOptions: {
            contact_type: lookups.contact_type || [],
            with_whom: lookups.with_whom || [],
            contact_location: lookups.contact_location || [],
            risk_type: lookups.risk_type || [],
        },
        wellbeingAreas: wellbeingResponse.data || [],
    };
};

const caseNoteOptions = {
    namespaced: true,
    state: () => ({
        loaded: false,
        lookupOptions: {
            contact_type: [],
            with_whom: [],
            contact_location: [],
            risk_type: [],
        },
        wellbeingAreas: [],
    }),
    mutations: {
        setOptions(state, options) {
            state.lookupOptions = options.lookupOptions;
            state.wellbeingAreas = options.wellbeingAreas;
            state.loaded = true;
        },
    },
    actions: {
        async load({ state, commit }) {
            if (state.loaded) return;

            if (!pendingRequest) pendingRequest = fetchCaseNoteOptions();

            try {
                const options = await pendingRequest;
                if (!state.loaded) commit("setOptions", options);
            } finally {
                pendingRequest = null;
            }
        },
    },
};

export default caseNoteOptions;
